import Button from "../Button";
import { ReactComponent as Sofa } from "../../assets/home/unique-features/background.svg";
import { GoPrimitiveDot } from "react-icons/go";

export default function UniqueFeatures() {
  return (
    <div className="w-full mt-14 py-5 bg-[#F1F0FF] font-fontTwo ">
      <div className=" max-w-5xl mx-auto flex h-[30rem] items-center">
        {/* left side (image container) */}
        <div className=" w-1/2 ">
          <div className="relative">
            <img
              className="absolute left-10 w-[28rem]"
              alt=""
              src={require("../../assets/home/unique-features/sofa.png")}
            />
            <Sofa className="w-[28rem]" />
          </div>
        </div>
        {/* right side (text) */}
        <div className=" ml-8">
          <h3 className=" text-3xl font-fontOne font-bold mb-5 text-text">
            Unique Features Of latest & Trending Products
          </h3>
          {/* list */}
          <div>
            {/* list element */}
            <ul>
              <li className="flex mb-2">
                <GoPrimitiveDot className=" text-pink mt-1 mr-3" />
                <p className=" text-[#ACABC3]">
                  All frames constructed with hardwood solid and laminates
                </p>
              </li>
              <li className="flex mb-2">
                <GoPrimitiveDot className=" text-text mt-1 mr-3" />
                <p className=" text-[#ACABC3]">
                  Reinforced with double wood dowels, glue, screw - nails corner
                  blocks and machine nails
                </p>
              </li>
              <li className="flex mb-2">
                <GoPrimitiveDot className=" text-green mt-1 mr-3" />
                <p className=" text-[#ACABC3]">
                  Arm, backs and seats are strcuturally reinforced
                </p>
              </li>
            </ul>
          </div>
          {/* bottom part */}
          <div className="flex items-end mt-7">
            {/* button */}
            <Button color="pink">Add To Cart</Button>
            {/* text beside button */}
            <p className=" text-sm ml-4 text-text ">
              <span className="font-semibold">B&B Italian Safa</span>
              <br /> $32.00
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
